import {
  Organization,
  OrganizationCompany,
} from 'models/CompanySetup/organization.model';
import { serializable, object } from 'serializr';

export class OrganizationDetails {
  @serializable(object(OrganizationCompany))
  company?: OrganizationCompany;

  @serializable(object(Organization))
  organization?: Organization;
}
